import enUS from "./en-US.js";
import zhCN from "./zh-CN.js";
import esMX from "./es-MX.js";
import jaJP from "./ja-JP.js";
import ptBR from "./pt-BR.js";
import ruRU from "./ru-RU.js";
import arEG from "./ar-EG.js";

import { i18nReplace } from "@/utils";
const messages = {
    en: i18nReplace(enUS),
    zh: i18nReplace(zhCN),
    mx: i18nReplace(esMX),
    jp: i18nReplace(jaJP),
    br: i18nReplace(ptBR),
    ru: i18nReplace(ruRU),
    eg: i18nReplace(arEG),
};

export default messages;
